'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        style: {
            fontSize: '13px',
            fontWeight: 'normal'
        }
    };
};
//# sourceMappingURL=noData.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/noData.js
 ** module id = 242
 ** module chunks = 0 1
 **/